var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsiveDesignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "url(#paint0_linear_316_7)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5833 55H50C47.2386 55 45 57.2386 45 60V90H95V60C95 57.2386 92.7614 55 90 55H80.4167",
    stroke: "#CAEBEB",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 93V90H101V93C101 96.3137 99.1494 99 96.8667 99H43.1333C40.8506 99 39 96.3137 39 93Z",
    stroke: "#CAEBEB",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3125 42.1562H64.6875C61.9261 42.1562 59.6875 44.3948 59.6875 47.1563V76.3438C59.6875 79.1052 61.9261 81.3438 64.6875 81.3438H75.3125C78.0739 81.3438 80.3125 79.1052 80.3125 76.3438V47.1562C80.3125 44.3948 78.0739 42.1562 75.3125 42.1562Z",
    stroke: "#CAEBEB",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9375 48.3438H72.0625",
    stroke: "#CAEBEB",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 77.2188C71.1391 77.2188 72.0625 76.2953 72.0625 75.1562C72.0625 74.0172 71.1391 73.0938 70 73.0938C68.8609 73.0938 67.9375 74.0172 67.9375 75.1562C67.9375 76.2953 68.8609 77.2188 70 77.2188Z",
    fill: "#CAEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3125 68.9688H59.6875",
    stroke: "#CAEBEB",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_7",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ADAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18CAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(37 37)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveDesignIcon);
export default __webpack_public_path__ + "static/media/responsive-design-icon.2dd391d8f86702ade78936ace96991c6.svg";
export { ForwardRef as ReactComponent };